var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlus2 = function SvgPlus2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M19.1 9.1h-8.2V.9c0-.5-.4-.9-.9-.9s-.9.4-.9.9v8.2H.9c-.5 0-.9.4-.9.9s.4.9.9.9h8.2v8.2c0 .5.4.9.9.9s.9-.4.9-.9v-8.2h8.2c.5 0 .9-.4.9-.9s-.4-.9-.9-.9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlus2);
export default ForwardRef;